import React, { useEffect } from 'react';
import './Styles.css';
import '@ids/style-modal-v19';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';
import { Ui16Cross } from '@ids/react-icons';

const Modal = ({ children, closeView, titleText, buttons }) => {
  useEffect(() => {
    const modal = document.getElementById('ids-modal-v19');
    if (modal) modal.showModal();
  }, []);

  return (
    <dialog className="if modal-v19 align-center modal-container" id="ids-modal-v19">
      <div className="modal-title-container">
        <h2 className="modal-title">{titleText}</h2>
        <IconButton
          type={IconButtonType.PLAIN}
          variant={IconButtonVariant.QUIET}
          size={IconButtonSize.SMALL}
          onClick={closeView}>
          <Ui16Cross />
        </IconButton>
      </div>
      {children}
      <div className="modal-button-container">{buttons}</div>
    </dialog>
  );
};

export default Modal;
